import { Link, useSearchParams } from "react-router-dom";
import Table from "../reusable_components/Table";
import { url } from "../utils/config";
import { btnOne, title } from "../utils/style";


function WorkOrders() {
    const [ searchParams ] = useSearchParams()

    const options = [
        {
            header: 'S. NO.',
            key: 'id'
        },
        {
            header: 'Service Bundle',
            key: 'bundleList'
        },
        {
            header: 'Services',
            key: 'serviceList'
        },
        {
            header: 'Parts',
            key: 'materialList'
        },
        {
            header: 'Others',
            key: 'otherList'
        },
        {
            header: 'Total Cost',
            key: 'totalCost'
        }
    ]

    return(
        <div className="p-4">
            <div className="flex justify-between py-2 mb-2">
                <div className={title}>Work Orders</div>
                <span>
                    <Link to={'/customer'} className={btnOne}>Customers</Link>
                </span>
            </div>

            <Table 
                options={options} 
                url={url + '/work_orders/' + searchParams.get('id')} 
                pagination 
                noFilter
            />
        </div>
    )
}

export default WorkOrders;